<template>
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="isRTL ? 'me-3 rotate-caret' : 'ms-3'"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="m-0 navbar-brand" href="/">
        <img :src="logo" class="navbar-brand-img h-100" alt="main_logo" />
        <span class="ms-1 font-weight-bold">Logo</span>
      </a>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="customClass"  v-if="false"/>
    <SidenavList-menu :cardBg="customClass" v-if="true"/>
  </aside>
</template>
<script>
import SidenavList from './SidenavList.vue'
import SidenavListMenu from './SidenavListMenu.vue'
import logo from '@/assets/Logo360-03.png'
import { mapState } from 'vuex'

export default {
  name: 'index',
  components: {
    SidenavList,
    SidenavListMenu
  },
  data () {
    return {
      logo
    }
  },
  props: {
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['isRTL'])
  }
}
</script>
